import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CFormSelect,
  CFormInput,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilTrash } from '@coreui/icons'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import PlusIcon from '../../../assets/plus-icon.svg'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import TemplateAccordion from '../templateAccordion'

const DefaultFooterModal = ({ componentData, modifyData, modalSpecificData, onCancel }) => {
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, setLoader } = useContext(AppContext)

  const [imageS3key, setImageS3key] = useState('')
  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState([])
  const [siteMap, setSiteMap] = useState([])
  const [link, setLink] = useState({ type: '', data: {} }) // default footer form subscribe btn link
  const [socialHandles, setSocialHandles] = useState([])

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: 'mdImage',
        width: 124,
        height: 70,
        divwidth: '14.16rem',
        divheight: '8rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        imagePaddingX: '7px',
        imagePaddingY: '7px',
      },
    ]
    let tempdata = componentData.data
    // console.log(tempdata)

    setImageS3key(tempdata.image_s3key)
    setSocialHandles(tempdata.social_handles)
    setSiteMap(tempdata.site_map)

    imgData[0]['assetId'] = tempdata.image_s3key
    imgData[0]['imageUrl'] = getThumbnail(
      userSessionObj?.session_data?.cf_domain_name,
      tempdata.image_s3key,
    )

    setImageData(imgData)
  }, [])

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (imageS3key.trim().length === 0) {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    if (link.type && !validateLink(link).isValid) {
      isFormValid = false
      temp.link = validateLink(link).error
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  // save component data
  const handleSave = () => {
    if (!validateInfo()) return

    let elementObj = {
      image_s3key: imageS3key,
      social_handles: socialHandles,
      site_map: siteMap,
    }

    modifyData(componentData.id, elementObj)
  }

  // delete social handle
  const deleteSocialHandle = (index) => {
    setSocialHandles((prevData) => prevData.filter((data, idx) => idx !== index))
  }
  // delete social handle
  const deleteSiteMap = (index) => {
    setSiteMap((prevData) => prevData.filter((data, idx) => idx !== index))
  }
  // add social handle
  const addSocialHandle = () => {
    setSocialHandles((prev) => [
      ...prev,
      {
        name: '',
        url: '',
      },
    ])
  }
  // change social item Name
  const changeSocialItemName = (value, idx) => {
    let tempSocialHandles = socialHandles
    tempSocialHandles[idx] = { ...tempSocialHandles[idx], name: value }
    setSocialHandles([...tempSocialHandles])
  }
  // change social item Url
  const changeSocialItemUrl = (value, idx) => {
    let tempSocialHandles = socialHandles
    tempSocialHandles[idx] = { ...tempSocialHandles[idx], url: value }
    setSocialHandles([...tempSocialHandles])
  }

  const addSiteMap = () => {
    setSiteMap((prev) => [
      ...prev,
      {
        text: '',
        link: {
          type: '',
          data: {},
        },
      },
    ])
  }

  let accordionItems = [
    {
      title: 'Add Logo',
      description: "Insert company's logo in the Footer",
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5' }}
          className=" px-4 py-3 d-flex flex-column justify-content-center align-items-center"
        >
          <ImageUploader data={imageData} />
          <span className="mt-2" style={{ fontSize: '11px', color: '#707070' }}>
            124 px X 70 px , maximum size 2 MB
          </span>
          <div className="message-text error-message">
            <p>{errorData.imageS3key}</p>
          </div>
        </div>
      ),
      itemStyle: '',
    },
    {
      title: 'Edit Sitemap',
      description: 'Specify the Sitemap and respective links',
      children: (
        <div
          style={{
            backgroundColor: '#e5e5e5',
            overflowX: 'auto',
            overflowY: 'auto',
            maxHeight: '290px',
          }}
          className=" px-4 py-1 custom-scrollbar-vertical"
        >
          {siteMap.map((item, idx) => (
            <div className="my-3 border px-3 py-3 rounded-2 bg-white" key={idx}>
              <h6 className="font-13px">Text {idx + 1}</h6>
              <CustomDescriptionBox
                limit={18}
                rows={1}
                value={item.text}
                onChange={(value) =>
                  setSiteMap((prev) => {
                    let temp = [...prev]
                    temp[idx] = { ...temp[idx], text: value }
                    return [...temp]
                  })
                }
                style={{ fontSize: '13px' }}
              />
              <AttachLink
                linkData={item.link}
                id={'text2'}
                categoryData={
                  categoryList
                    ? categoryList?.data.filter(
                        (info, idx) => info.type === 'category' && info.status,
                      )
                    : []
                }
                setLinkData={(value) =>
                  setSiteMap((prev) => {
                    let temp = [...prev]
                    temp[idx] = { ...temp[idx], link: value }
                    return [...temp]
                  })
                }
                selectorWidth={'70%'}
              />
            </div>
          ))}
          {siteMap.length < 5 && (
            <div
              className="my-3 overflow-hidden bg-[#fff] rounded w-full flex flex-col justify-center items-center cursor-pointer flex-shrink-0 p-3 -mt-2 mb-2"
              style={{
                borderRadius: '10px',
                boxShadow: ' 2px 2px 6px 0 rgba(0, 0, 0, 0.3)',
              }}
              onClick={() => addSiteMap()}
            >
              <div
                className="h-[24px] w-[24px] rounded-full bg-[#2172eb] flex justify-center items-center shadow"
                style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
              >
                <img src={PlusIcon} className="w-[15px] h-[15px]" alt="trashicon" />
              </div>
              <span className="text-sm font-medium mt-2 ">Add New Menu</span>
            </div>
          )}
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Add Social Media Links',
      description: 'Specify social links that you want to share with your viewers.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="">
            <h6 style={{ fontSize: '13px' }} className="">
              Select Social Link
              <span style={{ marginLeft: '13%' }}>URL</span>
            </h6>
            <div>
              {socialHandles.map((socialitem, idx) => (
                <div
                  className="d-flex justify-content-between items-center mb-3"
                  key={`${socialitem.name}${idx}`}
                >
                  <CFormSelect
                    size="sm"
                    style={{ width: '25%' }}
                    aria-label="Social handle seclector"
                    defaultValue={socialitem.name}
                    onChange={(e) => changeSocialItemName(e.target.value, idx)}
                  >
                    <option>Select</option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'facebook' ? true : null,
                      )}
                      value="facebook"
                    >
                      Facebook
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'instagram' ? true : null,
                      )}
                      value="instagram"
                    >
                      Instagram
                    </option>
                    {/* <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'linkedin' ? true : null,
                      )}
                      value="linkedin"
                    >
                      LinkedIn
                    </option> */}
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'bitchute' ? true : null,
                      )}
                      value="bitchute"
                    >
                      Bitchute
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'boxcast' ? true : null,
                      )}
                      value="boxcast"
                    >
                      Boxcast
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'rumble' ? true : null,
                      )}
                      value="rumble"
                    >
                      Rumble
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'telegram' ? true : null,
                      )}
                      value="telegram"
                    >
                      Telegram
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'tiktok' ? true : null,
                      )}
                      value="tiktok"
                    >
                      Tiktok
                    </option>
                    {/* <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'twitch' ? true : null,
                      )}
                      value="twitch"
                    >
                      Twitch
                    </option> */}
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'twitter' ? true : null,
                      )}
                      value="twitter"
                    >
                      Twitter
                    </option>
                    {/* <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'weixin' ? true : null,
                      )}
                      value="weixin"
                    >
                      WeChat
                    </option> */}
                    {/* <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'whatsapp' ? true : null,
                      )}
                      value="whatsapp"
                    >
                      WhatsApp
                    </option> */}
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'youtube' ? true : null,
                      )}
                      value="youtube"
                    >
                      Youtube
                    </option>
                  </CFormSelect>
                  <CFormInput
                    type="text"
                    size="sm"
                    style={{ width: '61%' }}
                    placeholder=""
                    aria-label="sm input example"
                    value={socialitem.url}
                    onChange={(e) => changeSocialItemUrl(e.target.value, idx)}
                  />
                  <div
                    className="w-[24px] h-[24px] d-flex justify-center items-center"
                    style={{ border: '1px solid #707070', borderRadius: '50%' }}
                    onClick={() => deleteSocialHandle(idx)}
                  >
                    <CIcon icon={cilTrash} size="md" />
                  </div>
                </div>
              ))}
            </div>
            {/* Add Link */}
            <div
              className="inline-flex justify-between items-center cursor-pointer"
              onClick={() => addSocialHandle()}
            >
              <div
                className="h-[24px] w-[24px] rounded-full bg-[#2172eb] flex justify-center items-center shadow"
                style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
              >
                <img src={PlusIcon} className="w-[15px] h-[15px]" alt="trashicon" />
              </div>
              <p className="text-xs text-[#2172eb] font-medium ml-1 mb-0">ADD LINK</p>
            </div>
            {/* Add Link Ending */}
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
  ]

  return (
    <>
      <CModal scrollable size="lg" className="" visible={true}>
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader className="d-flex justify-content-center" style={{ borderBottom: '0' }}>
          <p style={{ fontSize: '1.3rem' }}>
            <b style={{ fontWeight: '500' }}>Default Footer Editor</b>
          </p>
        </CModalHeader>
        <CModalBody
          style={{ minHeight: '72vh' }}
          className=" static-scrollbar-class d-flex flex-column justify-content-between"
        >
          <div className="d-flex justify-content-center">
            <div
              style={{ width: '82%' }}
              className="flex flex-column justify-content-center align-items-center"
            >
              <TemplateAccordion items={accordionItems} styles={''} />
            </div>
          </div>
        </CModalBody>
        <CModalFooter className="d-flex justify-content-center border-top-0">
          <div
            className="mt-4 d-flex align-items-end justify-content-between"
            style={{ width: '80%' }}
          >
            <span className="mt-2" style={{ fontSize: '12px' }}>
              * Leave a section blank to remove it from the component. Do not fill any details.
            </span>
            <CButton
              style={{ color: 'black', border: '1px solid black' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton
              style={{ backgroundColor: '#20211c' }}
              className="px-3 rounded-1 btn-focus-none"
              onClick={handleSave}
            >
              Save
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default DefaultFooterModal
